<div class="user-settings-list-of-requests-wrapper">
  <nz-divider
    nzText="{{ 'USER_SETTINGS.USER_SETTINGS_LIST_OF_REQUESTS' | translate }}"
    nzOrientation="center"></nz-divider>
  <div class="actions-wrapper">
    <button
      (click)="requestOwnData()"
      [disabled]="(loadingDataListingRequest$ | async) || !allowSentDataListingRequest"
      [matTooltip]="
        (loadingDataListingRequest$ | async) || allowSentDataListingRequest
          ? null
          : ('USER_SETTINGS.REQUEST_DATA_LISTING_TOOLTIP_IN_PROGRESS' | translate)
      "
      [matTooltipPosition]="'right'"
      [matTooltipDisabled]="(loadingDataListingRequest$ | async) || allowSentDataListingRequest"
      mat-raised-button
      class="request-data-listing-button"
      color="primary">
      {{ 'USER_SETTINGS.REQUEST_DATA_LISTING' | translate }}
    </button>
  </div>

  <app-cr-header>
    {{ 'USER_SETTINGS.USER_SETTINGS_MY_REQUESTS' | translate }}
  </app-cr-header>

  @if (dataListingRequests$ | async; as dataListingRequests) {
    <nz-table class="list-of-requests-table" #RequestsTable [nzData]="dataListingRequests" [nzHideOnSinglePage]="true">
      <caption class="sr-only">
        {{
          'USER_SETTINGS.USER_SETTINGS_REQUESTS_TABLE_CAPTION' | translate
        }}
      </caption>
      <thead>
        <tr>
          <th scope="col" class="requestedAt-cell">{{ 'USER_SETTINGS.LIST_OF_REQUESTS.REQUESTED_AT' | translate }}</th>
          <th scope="col" class="status-cell">{{ 'USER_SETTINGS.LIST_OF_REQUESTS.STATUS' | translate }}</th>
          <th scope="col" class="fulfilledAt-cell">{{ 'USER_SETTINGS.LIST_OF_REQUESTS.FULFILLED_AT' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (dataListingRequest of dataListingRequests; track dataListingRequest) {
          <tr>
            <td class="requestedAt-cell">{{ dataListingRequest.requestedAt | date: 'dd-MM-yyyy HH:mm' }}</td>
            @if (dataListingRequest.status === 'WAITING') {
              <td class="status-cell">
                <span class="waiting">{{ 'USER_SETTINGS.LIST_OF_REQUESTS.IN_PROGRESS' | translate }}</span>
              </td>
            }
            @if (dataListingRequest.status === 'CONFIRMED') {
              <td class="status-cell">
                <span class="confirmed">{{ 'USER_SETTINGS.LIST_OF_REQUESTS.DELIVERED' | translate }}</span>
              </td>
            }
            @if (dataListingRequest.status === 'CANCELED') {
              <td class="status-cell">
                <span class="canceled">{{ 'USER_SETTINGS.LIST_OF_REQUESTS.Rejected' | translate }}</span>
              </td>
            }
            <td class="fulfilledAt-cell">
              {{
                dataListingRequest.fulfilledAt && dataListingRequest.status === 'CONFIRMED'
                  ? (dataListingRequest.fulfilledAt | date: 'dd-MM-yyyy HH:mm')
                  : '-'
              }}
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  }
  @if ((loadingDataListingRequest$ | async) === true) {
    <div class="loading-container-in-section" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>
      <mat-spinner [diameter]="50" [attr.aria-hidden]="true"></mat-spinner>
      <div class="spinner-message" [innerHTML]="'USER_SETTINGS.LOADING_LIST_OF_REQUESTS' | translate"></div>
    </div>
  }
</div>
